import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'promoApplyTo'
})
export class PromoApplyToPipe implements PipeTransform {

  dict: {[id: number]: string} = [];

  constructor() {
    this.dict[0] = 'Todos los libros';
    this.dict[1] = 'Etiquetas';
    this.dict[2] = 'Libros';
  }


  transform(value: any): any {

    const result = (value != null) ? this.dict[value] : 'Aplica a:';
    return result;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/promo-apply-to.pipe.ts